/* eslint-disable max-len */
/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component } from '@angular/core';
import { ArticlesService } from '../../services/articles.service';
import { Logout } from '../../services/logout.provider';
import { ConfigService } from '../../services/config.service';
import { AuthProvider } from '../../services/auth.provider';
import { StorageProvider } from '../../services/storage.provider';
import { Multitenant } from '../../services/multitenant.provider';
import { PopUp } from '../../models/popup.model';
import { GaEventTrackerProvider } from '../../services/gaeventtracker.provider';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-page-profile-editor',
  templateUrl: 'profile-editor.html',
  styleUrls: ['profile-editor.scss']
})
export class ProfileEditorPage {

  public profiles: any;
  public error: string;
  public parentProfile = false;
  public teacherProfile = false;
  public proflen: number;
  public profile: any;
  public loggedPorfile: any;
  public noEdit: boolean;
  public tempPopUp: boolean;
  public popUpData: PopUp;
  public themeClass: string;
  public validProfiles: any = [];
  public isHidden: boolean;
  private access_token: string;
  private refresh_token: string;

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private articlesService: ArticlesService,
    private logout: Logout,
    private config: ConfigService,
    private auth: AuthProvider,
    private storage: StorageProvider,
    private multitenant: Multitenant,
    private ga: GaEventTrackerProvider
  ) {
    if(this.actRoute.snapshot.queryParams.access_token){
      this.access_token = this.actRoute.snapshot.queryParams.access_token;
    } else {
     this.access_token = storage.getStorage('access_token');
     this.refresh_token = storage.getStorage('refresh_token');
    }
  }

  ionViewDidEnter() {
    this.getProfiles(this.access_token);
    if(this.storage.getStorage('logged_profile_type') && this.storage.getStorage('logged_profile_type') === 'Parent'){
      this.parentProfile = true;
    }

    if(this.storage.getStorage('logged_profile_type') && this.storage.getStorage('logged_profile_type') === 'Teacher'){
      this.teacherProfile = true;
    }
    this.getLoggedProfile();

    if(this.storage.getStorage('cas')){
      this.noEdit = true;
    } else {
      this.noEdit = false;
    }

    this.themeClass = this.multitenant.getDomainClass();
  }

  getAvatar(): string {
    if(this.storage.getStorage('logged_profile_avatar')){
      return this.storage.getStorage('logged_profile_avatar');
    } else {
      return '';
    }
  }

  getLoggedProfile() {
    this.loggedPorfile = {
      profile_id: this.storage.getStorage('logged_profile_id'), profile_nickName: this.storage.getStorage('logged_profile_nickname')
    };
  }

  getProfiles(access_token: string) {
  	   this.articlesService.getUserProfiles(access_token).subscribe(response => {
        this.ga.gaSendUserId(response.user_id);
        if(!response.profiles){
          this.router.navigate(['creer-compte', 'etape-2']);
        } else {
          this.profiles = response.profiles;
          this.profiles[0].profile_type === 'Teacher' ? this.isHidden = true : this.isHidden = false;
          this.validProfiles = this.profiles.filter(profile => profile.access !== false);
          this.proflen = this.profiles.length;
          if(this.storage.getStorage('noProfiles')){
            this.storage.removeStorage('noProfiles');
          }
        }
		}, error => {
      if(error.message === 'Invalid tokens.'){
        this.logout.logOut();
        // this.navCtrl.push(HomePage);
        this.router.navigate(['']);
        this.error = ' Vos identifiants ne sont pas reconnus';
      }

      if(error.message === 'Number total of IP address connected is exceeded for this account') {
        this.error = 'ip';
      }
    });
  }

  navigateProfile(profile) {
    this.ga.trackEvent('Connexion d\'un utilisateur', profile.profile_type, profile.profile_is_free ? 'Gratuit' : 'Payant', null);
    if(!profile.access){
      this.tempPopUp = true;
      this.popUpData = new PopUp('noAccess', profile.profile_firstName);
    } else {
        const access = [];
        const mainAccess = [];
        const printAccess = [];
        const pdfAccess = [];
        for (const property in profile.access) {
          if (profile.access.hasOwnProperty(property) && profile.access[property].website) {
              access.push(property);
          }

          if(profile.access.hasOwnProperty(property) && profile.access[property].print){
            printAccess.push(property);

            if (profile.access[property].print.start[0] < AuthProvider.ONLY_PRINT_ACCESS_WITH_PDF_BEFORE_DATE) {
              pdfAccess.push(property);
            }
          }

          if(profile.access.hasOwnProperty(property) && profile.access[property].pdf){
            pdfAccess.push(property);
          }
        }

        access.sort(this.newspaperOrder);
        printAccess.sort(this.newspaperOrder);
        pdfAccess.sort(this.newspaperOrder);

        for (const property in profile.access) {
          if (profile.access.hasOwnProperty(property) && profile.access[property].website && (property === 'lepq' || property === 'mquo' ||
          property === 'actu' || property === 'aeco')) {
              mainAccess.push(property);
          }
        }

        mainAccess.sort(this.newspaperOrder);

        this.storage.setStorage('access', access.toString());
        this.storage.setStorage('mainaccess', mainAccess.toString());
        this.storage.setStorage('printaccess', printAccess.toString());
        this.storage.setStorage('pdfaccess', [...new Set(pdfAccess)].toString());
        if(this.actRoute.snapshot.queryParams.cas){
          sessionStorage.setItem('cas', 'true');
        }
        if(this.actRoute.snapshot.queryParams.kne){
          sessionStorage.setItem('kne', 'true');
        }

      if(profile.profile_type === 'Parent' && !sessionStorage.getItem('cas')){
        this.router.navigate(['loginprofile'], { queryParams: { profile: JSON.stringify(profile) } });
      } else {
        this.storage.setStorage('logged_profile_id', profile.profile_id);
        this.storage.setStorage('logged_profile_name', profile.profile_firstName);
        if(profile.profile_nickName){
          this.storage.setStorage('logged_profile_nickname', profile.profile_nickName);
        } else {
          this.storage.removeStorage('logged_profile_nickname');
        }
        this.storage.setStorage('logged_profile_type', profile.profile_type);
        if(profile.profile_avatar_path){
          this.storage.setStorage('logged_profile_avatar', profile.profile_avatar_path);
        } else {
          this.storage.removeStorage('logged_profile_avatar');
        }

        const newspaperAccess = Object.keys(profile.access);

        if(
          this.multitenant.getDomainClass() !== 'mwjp' && this.multitenant.getDomainClass() !== 'mwde' &&
          this.multitenant.getDomainClass() !== 'clfy' && this.multitenant.getDomainClass() !== 'mljp'
        ) {
          if (this.storage.getStorage('access') || this.storage.getStorage('printaccess')) {
            this.router.navigate(['']);
          } else if (this.storage.getStorage('pdfaccess')) {
            this.router.navigate(['pdf','choisir-un-titre']);
          }
        } else {
            this.router.navigate(['']);
        }
      }

    }
  }

  newspaperOrder(a, b) {
    const NEWSPAPER_ORDER = [
      'lepq', 'mquo', 'actu', 'aeco', 'mlwk', 'week', 'woch', 'sema'
    ];

    return NEWSPAPER_ORDER.indexOf(a) - NEWSPAPER_ORDER.indexOf(b);
  }

  addNewProfile() {
    this.router.navigate(['creer-profil']);
  }

  logOut() {
    this.logout.logOut();
    this.router.navigate(['']);
  }

  editProfile(profile) {
    this.router.navigate(['editer-profil'], { queryParams: { profile: JSON.stringify(profile) } });
  }

  isLogin() {
    return 'login';
  }

  isLoggedIn() {
    return this.auth.isAuthenticated();
  }

  onNotifyPopUp(message) {
    this.tempPopUp = false;
  }

  goToAddCupons() {
    this.router.navigate(['ajouter-code-gratuit']);
  }

  openAboSpace(profile) {
    const address = `https://espace-abonne.playbacpresse.fr/identification.html?subscriber_number=${profile.profile_subscriber_number}&access_token=${this.access_token}&refresh_token=${this.refresh_token}&subscriber_name=${profile.profile_lastName}`;
    window.open(address, '_blank');
  }

  getDefaultAvatar(profile): string {
    const avatar = this.config.getDefaultAvatar();
    return avatar[profile.profile_type];
  }

  getDefaultLoggedAvatar(): string {
    const avatar = this.config.getDefaultAvatar();
    return avatar[this.storage.getStorage('logged_profile_type')];
  }
  goBackToChooseProfile(){
    this.router.navigate(['profiles']);
  }
}
